import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import PrismCol from '../GridElements/PrismCol';

import CELL_PROP_TYPES from '../constants';

class DateCell extends React.PureComponent {
    static propTypes = {
        ...CELL_PROP_TYPES,
        value: PropTypes.string
    };

    render() {
        const {
            value,
            className
        } = this.props;

        const columnClassName = classNames(
            'prism-grid__body-column',
            'prism-grid__body-column_date',
            className
        );

        return (
            <PrismCol
                {...this.props}
                className={columnClassName}
            >
                {value}
            </PrismCol>
        );
    }
}

export default DateCell;
